const toggleTemplate = require("./toggle.html.slim")
declare var angular

export class Toggle {
  static $inject = ['$scope']
}

angular.module("wbComponents").directive("wbToggle", function() {
  return {
    restrict: "E",
    templateUrl: toggleTemplate,
    controller: Toggle,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      left: '@',
      right: '@',
      selected: '='
    }
  }
})
